import 'reflect-metadata';

import { configure } from 'mobx';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Container } from 'typedi';

import { App } from './components/App';
import { config, missingConfig } from './config';
import { createAnnouncementApi } from './services/announcementApi';
import { DevTokenAuthService, KeycloakAuthService } from './services/auth';
import { ANNOUNCEMENT_API, AUTH } from './services/types';

// State changes only in actions (web stack rule).
configure({ enforceActions: 'observed' });

const missing = missingConfig(config);
if (missing.length === 0) {
  const auth = config.devBearerToken
    ? new DevTokenAuthService(config.devBearerToken)
    : new KeycloakAuthService(config.keycloakUrl, config.keycloakRealm, config.keycloakClientId);
  Container.set(AUTH, auth);
  Container.set(
    ANNOUNCEMENT_API,
    createAnnouncementApi(config.announcementApiUrl, () => auth.getToken()),
  );
}

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing in public/index.html');
createRoot(root).render(
  <StrictMode>
    <App missingConfig={missing} />
  </StrictMode>,
);
